export default {
    departments(state, getters) {
        let unities = state.unities||[];
        let departments = unities
                                .map(({ departments, id:unity_id }) => departments.map(d => ({ ...d, unity_id})))
                                .reduce((acc, departments) => ([...acc, ...departments]), []);
        return departments;
    }
}